$(document).ready(function()
{
  $('body').on('change','.checkboxes input', function()
  {
    if ($('.checkboxes #age-check').is(':checked') && $('.checkboxes #terms-check').is(':checked') && $('.checkboxes #privacy-check').is(':checked'))
    {
       $('.additional-checkout-buttons').addClass('visible');
    }

    else
      $('.additional-checkout-buttons').removeClass('visible');
  });

  $('[name="checkout"], #cart-notification-form .button, #main-cart-footer #checkout').on('click', function()
  {
    if ($('.checkboxes #age-check').is(':checked') && $('.checkboxes #terms-check').is(':checked') && $('.checkboxes #privacy-check').is(':checked'))
    {
      return true;
    }
      
    else
    {
      if (!($('#age-check').is(':checked')) && ($('.checkboxes #terms-check').is(':checked')) && ($('.checkboxes #privacy-check').is(':checked')))
      {
        var html = '<div class="alert"><p>Wij verkopen alleen alcohol aan personen van 18 jaar en ouder.</p></div>';
      }

      else if (($('.checkboxes #age-check').is(':checked')) && !($('.checkboxes #terms-check').is(':checked')) && ($('.checkboxes #privacy-check').is(':checked')))
      {
        var html = '<div class="alert"><p>Je moet akkoord gaan met de algemene voorwaarden.</p></div>';  
      }

      else if (($('.checkboxes #age-check').is(':checked')) && ($('.checkboxes #terms-check').is(':checked')) && !($('.checkboxes #privacy-check').is(':checked')))
      {
        var html = '<div class="alert"><p>Voor de verwerking van jouw gegevens moet je ons privacybeleid hebben gelezen.</p></div>';  
      }

      else
      {
        var html = '<div class="alert"><p>Wij verkopen alleen alcohol aan personen van 18 jaar en ouder. Je moet ook akkoord gaan met de algemene voorwaarden en het privacybeleid lezen.</p></div>';
      }

      $(html).appendTo('body').modal();      
      return false;
    }
  });
});
